"use client";

import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useAuth } from "@/contexts/authContext";
import { GET_NOTIFICATIONS_COUNT } from "@/api/apollo-client/queries/Queries";
import { setNotificationCount } from "@/lib/features/notificationSlice";

const NotificationBell = () => {
  const { isAuthenticated } = useAuth();
  const dispatch = useDispatch();

  const { data } = useQuery(GET_NOTIFICATIONS_COUNT, {
    skip: !isAuthenticated,
    fetchPolicy: "network-only", // Ensures fresh data on mount without polling
  });

  useEffect(() => {
    if (data) {
      dispatch(setNotificationCount(data.getUnreadNotifications || 0));
    }
  }, [data, dispatch]);

  return null; // This component does not render anything
};

export default NotificationBell;
